import React from 'react';
/** Контекст для трекинга аналитики */
export default React.createContext();
